export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Research Planning', description: 'Collaborate with product and design teams to plan research activities', frequency: 'Weekly planning sessions' },
      { name: 'User Interviews', description: 'Conduct user interviews and usability testing sessions', process: 'Schedule, conduct, and document findings' },
      { name: 'Research Synthesis', description: 'Analyze and synthesize research findings into actionable insights', deliverable: 'Research reports and presentations' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Research team communication and updates', channels: ['#ux-research', '#design-team', '#product-team'] },
      { name: 'Figma', purpose: 'Design review and prototype testing', access: 'Viewer/commenter permissions' },
      { name: 'Notion', purpose: 'Research documentation and knowledge sharing', permissions: 'Editor access to research spaces' }
    ],
    processes: [
      { name: 'Research Request Process', steps: ['Receive research request', 'Define research questions', 'Plan methodology', 'Execute research', 'Share findings'] },
      { name: 'Usability Testing', steps: ['Create test plan', 'Recruit participants', 'Conduct sessions', 'Analyze results', 'Present recommendations'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Research Operations', description: 'Establish and maintain research processes and systems', responsibility: 'Research process optimization' },
      { name: 'Cross-functional Collaboration', description: 'Work with multiple teams to integrate research insights', scope: 'Product, design, engineering, and marketing alignment' },
      { name: 'Research Program Management', description: 'Manage multiple research projects and priorities', commitment: 'Strategic research planning' }
    ],
    tools: [
      { name: 'Dovetail', purpose: 'Research repository and insight management', access: 'Admin permissions for research organization' },
      { name: 'Amplitude', purpose: 'Product analytics and behavioral data analysis', access: 'Analytics dashboard and reporting' },
      { name: 'Maze', purpose: 'Remote usability testing and user journey analysis', permissions: 'Test creation and analysis' }
    ],
    processes: [
      { name: 'Research Strategy Development', steps: ['Assess research needs', 'Define research roadmap', 'Align with business goals', 'Execute strategic research'] },
      { name: 'Insight Democratization', steps: ['Organize research findings', 'Create accessible reports', 'Train teams on insights', 'Monitor insight adoption'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Research Leadership', description: 'Lead research strategy and team development', responsibility: 'Research program leadership and mentoring' },
      { name: 'Organizational Impact', description: 'Drive research-informed decision making across the organization', scope: 'Company-wide research influence' },
      { name: 'Research Innovation', description: 'Explore and implement new research methodologies and technologies', impact: 'Research practice advancement' }
    ],
    tools: [
      { name: 'Research Operations Platform', purpose: 'Enterprise research management and automation', role: 'Platform administrator and strategist' },
      { name: 'Advanced Analytics Suite', purpose: 'Complex data analysis and predictive modeling', access: 'Full analytics platform access' },
      { name: 'AI Research Tools', purpose: 'AI-powered research analysis and automation', role: 'AI research implementation lead' }
    ],
    processes: [
      { name: 'Research Program Strategy', steps: ['Define research vision', 'Build research capabilities', 'Measure research impact', 'Scale research practices'] },
      { name: 'Research Culture Development', steps: ['Evangelize research value', 'Train organization on research', 'Build research-driven culture', 'Measure cultural impact'] }
    ]
  }
};
